module.exports = __webpack_public_path__ + "static/img/Ginnivan.3fea832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ginnivan.jpg
// module id = 7BPU
// module chunks = 0